<!-- Dialog -->
<div class="dialog" (click)="close()">
    <mat-icon (click)="moveImage(-1,$event)" class="mat-icon-left">chevron_left</mat-icon>
    <mat-icon (click)="moveImage(1,$event)" class="mat-icon-right">chevron_right</mat-icon>
    <div mat-dialog-content>
        <div class="img-container" (click)="stopePropagation($event)">
            <img src="{{images[selectedImage]}}" alt="">
        </div>
    </div>
</div>
<mat-icon (click)="close()" class="mat-icon-close">close</mat-icon>
<!-- <div class="exit-dialog" (click)="close()">        
    <app-material-exit-dialog></app-material-exit-dialog>
</div> -->